import { IUser } from './user.model';

export interface IInvite {
  status: string;
  invitedBy: IUser;
  organization: {
    _id: '';
    name: '';
  };
  _id: string;
  userEmail: string;
  memberRoles: string[];
}

export enum EInviteStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING'
}
